<template>
  
  <div>
    <div class="py-2 font-weight-bold caption px-2">
      New Signature Request:
    </div>
    
    <div class="px-3">
      <app-browse-contacts
          v-if="$store.state.localData && userInfo.userID"
          :value="[request.targetId]"
          :multi-select="false"
          :folder-filter="filterTargetFolder"
          :disabled="chatType === 'c'"
      >
        <template #activator>
          <v-text-field
              :disabled="loading"
              prepend-icon="3p"
              hide-details
              label="Target:"
              placeholder="Any Contact, Click to select"
              readonly
              :value="targetNameStr"
              style="cursor: pointer !important;"
              :clearable="chatType !== 'c'"
              @click:clear.stop.prevent="request.targetId = null"
          ></v-text-field>
        </template>
        
        <template #actions="{selectedContacts, hideDialog}">
          
          <v-card-actions class="c-d-flex c-justify-end">
            <v-btn
                @click="() => hideDialog()"
                flat
            >
              Cancel
            </v-btn>
            
            <v-btn
                :disabled="!Array.isArray(selectedContacts) || !selectedContacts.length"
                color="secondary"
                @click="updateTargetContact(selectedContacts, hideDialog)"
            >
              Select Contact
            </v-btn>
          </v-card-actions>
        
        </template>
      
      </app-browse-contacts>
      
      <v-textarea
          prepend-icon="question_mark"
          hide-details
          label="Prompt:"
          style="cursor: pointer"
          :rows="1"
          :auto-grow="true"
          :disabled="loading"
          v-model="request.prompt"
      ></v-textarea>
    </div>
    
    <div class="pt-2 text-xs-right">
      <v-btn
          :disabled="loading"
          flat
          small
          @click="$emit('cancel')"
      >
        Cancel
      </v-btn>
      
      <v-btn
          :disabled="loading"
          :loading="loading"
          small
          color="secondary"
          @click="$emit('send')"
      >
        Send
      </v-btn>
    </div>
    
  </div>

</template>

<script>

import {SignatureRequestTemplate} from "@/Tasks/TaskView V2/components/Chat Message/AppComboComposeMessage.vue"

import draggable from "vuedraggable";
import AppBrowseContacts from "@/contacts/AppBrowseContacts.vue";
import {mapGetters} from "vuex";

export default {
  components: {
    AppBrowseContacts,
    draggable,
  },
  props: {
    editRequest: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    filterTargetFolder: Number,
    filterTarget: String,
  },
  data() {
    return {
      console,
      request: new SignatureRequestTemplate({}),
      loadingTargetContactInformation: false,
      targetContactInformation: null,
      chatType: 't',
    }
  },
  watch: {
    editRequest: {
      immediate: true,
      deep: true,
      handler(v) {
        this.request = new SignatureRequestTemplate(v)
      }
    },
    
    "request.targetId": {
      immediate: true,
      handler(val) {
        this.targetContactInformation = null;
        if (val)
          this.getTargetContactInformation()
      }
    },
    
    filterTarget: {
      immediate: true,
      handler(val) {
        const [type, channelId, contactId] = val.split('-')
        this.chatType = type
        if (type === 'c') {
          this.request.targetId = +contactId
        }
      }
    }
  },
  methods: {
    
    async getTargetContactInformation() {
      try {
        this.loadingTargetContactInformation = true
        const contactInfo = await this.$newReq('GET', `contacts/contactInfo/${this.request.targetId}`)
        this.$set(this, "targetContactInformation", contactInfo)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.loadingTargetContactInformation = false
      }
      
    },
    
    updateTargetContact(selectedContacts, hideDialog) {
      this.request.targetId = selectedContacts.shift().id
      hideDialog()
    },
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    targetNameStr() {
      if (this.loadingTargetContactInformation)
        return 'LOADING...'
      return this.targetContactInformation?.fullName || null
    }
  
  
  },
}
</script>



<style scoped>

</style>